import React, { useContext, useEffect, useState } from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'
import { IoMdArrowDropdown } from 'react-icons/io'
import { IoChevronBackOutline } from 'react-icons/io5'
import { BiCheck } from 'react-icons/bi'

import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import BVCalendar from '../../components/calendar'
import { AiOutlinePlusCircle, AiFillFolder, AiFillFile, AiFillCheckCircle, AiOutlinePlus, AiOutlineCloseCircle, AiOutlineUpload, AiOutlineTags } from 'react-icons/ai'
import { FiCornerRightDown } from 'react-icons/fi'
import { MdFamilyRestroom } from 'react-icons/md'
import { AlertContext } from '../../context/alert_context'
import { Service } from '../../services/api'
import { gray30, primary } from '../../utils/colors'
import { useFilePicker } from 'use-file-picker'
import { useParams } from 'react-router-dom'
import Loader from '../../components/loader'

export default function AgregarDocumento({ ...props }) {
    const { cita_id } = useParams()
    const { notify } = useContext(AlertContext)
    const [state, setState] = useState({
        step: props.step === undefined ? 0 : props.step,
        file_type_selected: null,

        doc_name: '',
        doc_hash: '',
        doc_description: '',
        doc_tags: [],
        doc_image: null,
        doc_document: null,
        doc_image_temp: null,
        doc_document_temp: null,

        tag: '',
        tags: [],
        tip: '',
        tips: [],
        tags_selected: [],
        loading: false
    })

    const { openFilePicker, filesContent, loading, plainFiles } = useFilePicker({
        readAs: 'DataURL',
        accept: 'image/*, .pdf',
    });

    useEffect(() => {

        console.log(filesContent)
        console.log(plainFiles)

        if (filesContent.length == 0) {
            console.log("NO HAY");
            return
        }



        switch (state.file_type_selected) {
            case 'doc':

                console.log("DOOOC")
                state.doc_document_temp = filesContent[0];
                state.doc_document = plainFiles[0]
                state.doc_name = filesContent[0].name
                break;
            case 'img':
                console.log("IMAGEE")
                state.doc_image_temp = filesContent[0];
                state.doc_image = plainFiles[0]
                break;
            default:
                break;
        }

        setState({ ...state, file_type_selected: null })




        return () => { }


    }, [filesContent, plainFiles])


    useEffect(() => {
        const init = async () => {
            let tags = await Service('GET', `Tag?pageNumber=1&pageSize=999`);
            let tips = await Service('GET', `Tip?pageNumber=1&pageSize=999`);
            setState({ ...state, tags: tags.data.data, tips: tips.data.data });
        };
        init()
        return () => { }
    }, [])

    const onAddDoc = async () => {



        const body = new FormData();
        let tags_selected = [];

        for (const tag of state.tags_selected) {

            tags_selected.push(tag.id)
        }

        if (
            state.doc_document === null ||
            state.doc_img === null ||
            state.doc_name === '' ||
            state.doc_description === ''
        ) {
            notify({ title: 'Agregar Documento', message: 'Debes completar los campos obligatorios', type: 'error' })
            return;
        }


        body.append('Title', state.doc_name)
        body.append('HashTip', state.doc_hash)
        body.append('DocumentUrl', state.doc_document)
        body.append('ImageUrl', state.doc_image)
        body.append('Description', state.doc_description)

        for (const tag of state.tags_selected) {
            body.append('Tags', tag.id)
        }
        if (cita_id) {
            body.append('AppointmentId', cita_id)
        }
        setState({ ...state, loading: true })

        let add_tip = await Service('POSTMEDIA', 'Document', body);
        console.log(add_tip)


        if (add_tip.status === 200) {
            notify({ title: 'Agregar Documento', message: '¡Listo! Se agrego nuevo Documento', type: 'success' })
        } else {
            notify({ title: 'Agregar Documento', message: 'Error!  Algo salio mal, intenta de nuevo más tarde.', type: 'error' })
        }
        setState({ ...state, loading: false })
        props.onCancel();
    }

    const onFilterTips = () => {


        return state.tips.filter((tag) => {

            if (state.tip.length < 3) {
                return false;
            }

            if (tag.title.toUpperCase().includes(state.tip.toUpperCase())) {
                return true
            }
            return false

        })
    }
    const onFilterTags = () => {


        return state.tags.filter((tag) => {

            if (state.tag.length < 3) {
                return false;
            }

            if (tag.name.toUpperCase().includes(state.tag.toUpperCase())) {
                return true
            }
            return false



        })
    }
    const onSelectDocFile = () => {
        state.file_type_selected = 'doc'
        openFilePicker()
    }
    const onSelectDocImage = () => {
        state.file_type_selected = 'img'
        openFilePicker()
    }

    return (
        <>
            <Renderif isTrue={state.loading}>
                <Loader></Loader>
            </Renderif>
            <div className='overlay d-flex justify-content-center align-items-center'>

                <div className='bv-modal shadow'>

                    <div className='py-3 px-4 d-flex align-items-center bg-white b-bottom'>
                        <div className='f-14 bold text-gray'>Agregar Documento</div>
                        <div className='col'></div>
                        <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                            props.onCancel()
                        }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                    </div>

                    <div className='px-4 pb-4 overflow-auto hide-scroll'>

                        <Renderif isTrue={state.step === 0}>

                            <div className='d-flex align-items-center pt-3 mt-5'>



                                <div className='col me-1 position-relative'>

                                    <div className='bv-list-select hide-scroll' style={{ marginTop: '-' + ((onFilterTips().length * 44 + 44) >= 256 ? '264' : (onFilterTips().length * 44 + 44)).toString() + 'px' }}>



                                        {
                                            onFilterTips().map((tip, i) => {

                                                return (
                                                    <div className='bv-list-select-item' key={i} onClick={() => {
                                                        console.log(tip)
                                                        // onAddTag({tag})

                                                    }}>
                                                        <div className='bv-icon'><AiOutlineTags color={primary} /></div>
                                                        <div className='f-12 bold'>{tip.title}</div>
                                                    </div>
                                                )
                                            })
                                        }
                                        <div className='bv-list-select-item sticky-bottom bg-white b-top' onClick={() => {

                                            setState({ ...state, step: 1 })

                                        }}>
                                            <div className='bv-icon'><AiOutlinePlus color={primary} /></div>
                                            <div className='f-12 bold'>Agregar nuevo</div>
                                        </div>
                                    </div>

                                    <input placeholder='Buscar Tips' type={'text'} value={state.tip} onChange={(evt) => {

                                        setState({ ...state, tip: evt.currentTarget.value })

                                    }} className='input--light' />






                                </div>



                            </div>

                        </Renderif>

                        <Renderif isTrue={state.step === 1}>
                            <div className='mt-3'>

                                <div className='d-flex'>
                                    <div className='col me-2'>
                                        <div className='f-12 text-gray'>Seleccionar Documento (Obligatorio)</div>
                                        <div className='d-flex'>
                                            <input disabled type={'text'} value={state.doc_document_temp?.name} onChange={() => { }} placeholder="" className='input--light'></input>

                                            <div className='bv-cta bv-cta--outline ms-2' onClick={() => {
                                                onSelectDocFile()
                                            }}>
                                                <div className='bv-icon bv-icon--mid'><AiOutlineUpload size={26} color={gray30}></AiOutlineUpload></div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col me-2'>
                                        <div className='f-12 text-gray'>Nombre del documento (Obligatorio)</div>
                                        <input type={'text'} value={state.doc_name} onChange={(evt) => { setState({ ...state, doc_name: evt.currentTarget.value }) }} placeholder="" className='input--light'></input>
                                    </div>
                                    <div className='col'>
                                        <div className='f-12 text-gray'>Hash del documento (Opcional)</div>
                                        <input type={'text'} value={state.doc_hash} onChange={(evt) => { setState({ ...state, doc_hash: evt.currentTarget.value }) }} placeholder="" className='input--light'></input>
                                    </div>
                                </div>

                                <div className='mt-3'>
                                    <div className='f-12 text-gray'>Descripción (Obligatorio)</div>
                                    <textarea rows={3} value={state.doc_description} onChange={(evt) => { setState({ ...state, doc_description: evt.currentTarget.value }) }} className='input--light py-1'></textarea>
                                </div>

                                <div className='position-relative mt-3'>

                                    <div className='bv-list-select hide-scroll' style={{ marginTop: '-' + ((onFilterTags().length * 44) >= 256 ? '264' : (onFilterTags().length * 44)).toString() + 'px' }}>

                                        {
                                            onFilterTags().map((tag, i) => {
                                                return (
                                                    <div className='bv-list-select-item' key={i} onClick={() => {

                                                        state.tags_selected.push(tag)


                                                        setState({ ...state, tag: '' })

                                                    }}>
                                                        <div className='bv-icon'><AiOutlineTags color={primary} /></div>
                                                        <div className='f-12 bold'>{tag.name}</div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>

                                    <div className='f-12 text-gray'>Agregar etiquetas (Optional)</div>
                                    <input type={'text'} value={state.tag} onChange={(evt) => {
                                        console.log(evt.currentTarget.value)
                                        setState({ ...state, tag: evt.currentTarget.value })

                                    }} className='input--light'></input>

                                    <div>
                                        {state.tags_selected?.map((item, i) => {
                                            console.log(item)
                                            return (
                                                <div key={i} className='bv-tag'>
                                                    <div className='px-1 text-white'>{item.name}</div>
                                                    <div className='ps-0 cursor-pointer' onClick={() => {
                                                        state.tags_selected = state.tags_selected.filter((tag) => tag !== item)
                                                        setState({ ...state })
                                                    }}> <AiOutlineCloseCircle size={22} color={'white'} /></div>
                                                </div>
                                            )
                                        })}
                                    </div>


                                </div>






                                {/* <div className='mt-3'>
                                    <div className='f-12 text-gray mb-1'>(Obligatorio)</div>


                                    <div className='d-flex align-items-center'>


                                        <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={() => {
                                            onSelectDocImage()
                                        }}>
                                            <div className='ps-1'> <AiOutlineUpload size={20} /></div>
                                            <div className='px-1'>Agregar Imagen</div>
                                        </div>

                                        <div className='col'></div>
                                        <div>

                                            <img width="100px" className='bv-card' src={state.doc_image_temp?.content}></img>
                                        </div>


                                    </div>

                                </div> */}
                            </div>
                        </Renderif>

                    </div>

                    <div className='d-flex b-top py-3 px-4  bg-white'>
                        <div className='col'></div>
                        <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                            props.onCancel();
                        }}>Cancelar</div>
                        <Renderif isTrue={state.step === 1}>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                onAddDoc()
                            }}>Continuar</div>
                        </Renderif>

                    </div>

                </div>


            </div>
        </>
    )
}
